import React, { FC, createContext, useContext, useMemo } from 'react';
import type { IEnvironment } from 'relay-runtime';

import type { CreateRelayEnvironmentOptions } from '../types';

// istanbul ignore next
export const LazyRelayAppWrapper: FC<CreateRelayEnvironmentOptions> = ({
  children,
  acquireToken,
  host,
  isFeatureEnabled,
}) => {
  const lazyEnv = useMemo(
    async () =>
      (await import(/* webpackChunkName: "4-feat-relay" */ '../environment')).createRelayEnvironment({
        acquireToken,
        host,
        isFeatureEnabled,
      }),
    [acquireToken, host, isFeatureEnabled]
  );

  return (
    <RelayAppEnvironmentPromiseContext.Provider value={lazyEnv}>{children}</RelayAppEnvironmentPromiseContext.Provider>
  );
};

type RelayAppEnvironmentPromise = Promise<IEnvironment> | undefined;
const RelayAppEnvironmentPromiseContext = createContext<RelayAppEnvironmentPromise>(undefined);

type UseRelayAppEnvironmentPromise = () => RelayAppEnvironmentPromise;
/* istanbul ignore next */
export const useRelayAppEnvironmentPromise: UseRelayAppEnvironmentPromise = () =>
  useContext(RelayAppEnvironmentPromiseContext);
